import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import MapPane from './map-pane';
import DetailsPane from './detail-pane';
import { GET_LISTING } from 'graphql/listing';
import { setListing } from 'reducers/viewListingReducer';

const ViewListing = () => {
  const { listingId } = useParams();
  const dispatch = useDispatch();
  const { data } = useQuery(GET_LISTING, {
    variables: {
      listingId
    },
    skip: !listingId
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    const listing = data.listing;
    const {
      id,
      title,
      introduction,
      price,
      area,
      tasks,
      pricingOption,
      sellingOption,
      bounds,
      landParcels,
      images
    } = listing;
    dispatch(
      setListing({
        id,
        title,
        introduction,
        price,
        area,
        tasks,
        pricingOption,
        sellingOption,
        landParcels: landParcels.map(p => ({
          id: p.id,
          coordinates: p.polygon.points.map(p => [p.lng, p.lat]),
          area: p.area
        })),
        images,
        bounds: [
          [bounds[0].lng, bounds[0].lat],
          [bounds[1].lng, bounds[1].lat]
        ]
      })
    );
  }, [data]);

  return (
    <Card className="view-listing-body">
      <Card.Body className="h-100">
        <Row className="h-100">
          <Col md={6} className="h-100">
            <DetailsPane></DetailsPane>
          </Col>
          <Col md={6} className="h-100">
            <MapPane></MapPane>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ViewListing;
